import { serviceMaker, methods, api } from "../index";

export const createClosedUser = (data) =>
  serviceMaker(`/groupsdetails`, methods.POST, api.NGB, data);
  
export const getClosedUserList = () =>
  serviceMaker(`/groupsdetails?limit=14&offset=0`, methods.GET, api.NGB);
